import { render } from "./SkipassIcon.vue?vue&type=template&id=8cd8fd1c&scoped=true"
const script = {}

import "./SkipassIcon.vue?vue&type=style&index=0&id=8cd8fd1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd8fd1c"]])

export default __exports__